import {Box} from "@mui/material";
import {ElevationApp} from "../ElevationApp";
import {useFrmVar} from "../util/useFrmVar";
import {DimensionField} from "./DimensionField";
import {SidebarSection} from "./SidebarSection";

// the door sidebar's Stiles section: the side stiles, top rail and bottom rail a lite
// must stay inside (see MdDoorSpec.stileSide / stileTop / stileBottom).
export function StilesSection(props: {app: ElevationApp}) {
    const door = props.app.doorSpec;
    const sys = props.app.project?.unitSystem || "imperial";

    const side = useFrmVar(door.stileSide);
    const top = useFrmVar(door.stileTop);
    const bottom = useFrmVar(door.stileBottom);

    return (
        <SidebarSection title="Stiles" defaultExpanded>
            <Box sx={{display: "flex", flexDirection: "column", gap: 0.5, px: 1.5, pb: 1}}>
                <DimensionField label="Sides" value={side} sys={sys} onChange={v => door.stileSide.userSet(v, {debug: "sidebar.stileSide"})} />
                <DimensionField label="Top" value={top} sys={sys} onChange={v => door.stileTop.userSet(v, {debug: "sidebar.stileTop"})} />
                <DimensionField label="Bottom" value={bottom} sys={sys} onChange={v => door.stileBottom.userSet(v, {debug: "sidebar.stileBottom"})} />
            </Box>
        </SidebarSection>
    );
}
